module.exports = __webpack_public_path__ + "img/international-2.5fe19e46.jpg";